import {createSlice, PayloadAction} from '@reduxjs/toolkit';
import {IAssignmentDataResponse, IAssignmentGroupNode} from '../../api/types/assignment.type';
import {IMetadataItem} from '../../shared/interfaces';

export interface liveCategorySequence {
  categoryFieldId: number;
  categoryName: string;
  seq: number;
  categoryDirection: boolean;
}

export interface ISelectedData {
  type: string;
  mode: string;
  assignmentId: number;
  assignmentGroupId: number;
}
interface AssignmentState {
  listData: {
    assignedMetadata: any[];
    codingFormsList: any[];
    classification: any[];
    unAssignedMetadata: any[];
    additionalPreferences: any;
    docPresentationSorting: {
      lstCategorySeq: liveCategorySequence[];
      lstMetaDataFieldModel: any[];
    };
    lstKeywordsModel: any[];
  };
  formData: {
    selectedSeq: string;
    assignmentModel: {
      isAssignmentGroup: boolean;
      assignmentID: number;
      assignmentInstructions: string;
      assignmentName: string;
      parentAssignmentGroupID: number;
      parentassignmentGroupName: string;
      isCascadeEnabled: boolean;
      classificationLevelID: number;
      parentsIsCascadeEnabled: boolean;
      codingFormID: number;
      isActive: boolean;
      priority: number;
      isDrawFromPool: boolean;
      drawFromPoolCount: number;
      isKeepFamiliesTogether: boolean;
      isKeepEmailThreadsTogether: boolean;
      keepFamiliesTogetherCount: number;
      range_2a: number;
      additionalPreferences: {
        isShowMiniDocList: boolean;
        isAllowPopoutPanels: boolean;
        isAllowReviwerRemarks: boolean;
        isAllowFolderActions: boolean;
        isShowDefaultViewTab: boolean;
        isEnableHightlighting: boolean;
        isExposeDocumentHistory: boolean;
        isAllowAccesstoFullDoclist: boolean;
        isShowAnalyticsPanel: boolean;
        isEnableRecommendations: boolean;
        isAllowMetadataView: boolean;
        isAllowCodingOutsideReviwerBatch: boolean;
        isAllowCodingStamps: boolean;
        isShowAssignmentProgress: boolean;
        isAllowProductionView: boolean;
        isAllowSaveWithoutCompletion: boolean;
        isEnableRedactions: boolean;
        isNearNativeView: boolean;
        isPreCreatedTIFFImg: boolean;
        isAllowManualSort: boolean;
        isAllowPDFPrinting: boolean;
        isAllowNativeDownloads: boolean;
        isShowEmailThreadMaptabAnalyticsPanel: boolean;
        isShowNearDuplicatetabAnalyticsPanel: boolean;
        isShowFamilyMemberstabAnalyticsPanel: boolean;
        isShowConceputallySimilartabAnalyticsPanel: boolean;
        isShowRelatedDocstab: boolean;
        isShowFoldersTab: boolean;
        shouldCompleteOnApplyCodingStamp: boolean;
        isAutoSaveCodingForm: boolean;
        isShowAiPredictionHints: boolean;
      };
      docPresentationSorting: {
        isCategory: boolean;
        isMetadata: boolean;
        selectedMetaDataFieldId: number;
        metaDataSeq: number;
        metaDataDirection: boolean;
        isImportList: boolean;
        isAIScore: boolean;
        selectedModelAiScoreId: number;
        aiScoreModelDirection: boolean;
        shouldDisplayEmailTogether: boolean;
        shouldDisplayFamilyTogether: boolean;
        aiChkForFamilyTogether: boolean;
        aiChkForEmailsTogether: boolean;
        metadatChkForFamilyTogether: boolean;
        metadataChkForEmailsTogether: boolean;
      };
      selectCodingFormLists: string;
      pageSize: number;
      pageNumber: number;
      isAscending: string;
      sortingColumn: string;
      totalDocuments: number;
      unAssignedDocuments: number;
      noOfDocToDistribute: number;
      assignmentKeywordIds: string[];
      assignmentMetaDataIds: string[];
      isTemporary: boolean;
      isLockNeeded: boolean;
      isAIEnabled: boolean;
      distributeFamilyDocuments: boolean;
      distributeEmailThreadDocuments: boolean;
    };
  };
  assignmentList: IAssignmentDataResponse;
  selectedData: ISelectedData;
  bulkAssignFlowData: {
    isBulkAssignFlow: boolean;
    parentGroupId: number | null;
    masterDocListId: number | null;
    assignmentId: number | null;
    bulkActionId: number | null;
  };
  backSourceTabIndex: number | null;
  assignmentTree: IAssignmentGroupNode[];
}

const initialState: AssignmentState = {
  listData: {
    assignedMetadata: [],
    codingFormsList: [],
    classification: [],
    unAssignedMetadata: [],
    additionalPreferences: [],
    docPresentationSorting: {
      lstCategorySeq: [],
      lstMetaDataFieldModel: [],
    },
    lstKeywordsModel: [],
  },
  formData: {
    selectedSeq: '',
    assignmentModel: {
      isAssignmentGroup: false,
      assignmentID: 0,
      assignmentInstructions: '',
      assignmentName: '',
      parentAssignmentGroupID: -1,
      parentassignmentGroupName: 'root',
      isCascadeEnabled: false,
      classificationLevelID: 1,
      parentsIsCascadeEnabled: false,
      codingFormID: 0,
      isActive: true,
      priority: 1,
      isDrawFromPool: true,
      drawFromPoolCount: 100,
      isKeepFamiliesTogether: true,
      isKeepEmailThreadsTogether: true,
      keepFamiliesTogetherCount: 0,
      range_2a: 3,
      additionalPreferences: {
        isShowMiniDocList: true,
        isAllowPopoutPanels: true,
        isAllowReviwerRemarks: true,
        isAllowFolderActions: true,
        isShowDefaultViewTab: true,
        isEnableHightlighting: true,
        isExposeDocumentHistory: true,
        isAllowAccesstoFullDoclist: true,
        isShowAnalyticsPanel: true,
        isEnableRecommendations: true,
        isAllowMetadataView: true,
        isAllowCodingOutsideReviwerBatch: true,
        isAllowCodingStamps: true,
        isShowAssignmentProgress: true,
        isAllowProductionView: true,
        isAllowSaveWithoutCompletion: true,
        isEnableRedactions: true,
        isNearNativeView: true,
        isPreCreatedTIFFImg: true,
        isAllowManualSort: true,
        isAllowPDFPrinting: true,
        isAllowNativeDownloads: true,
        isShowEmailThreadMaptabAnalyticsPanel: true,
        isShowNearDuplicatetabAnalyticsPanel: true,
        isShowFamilyMemberstabAnalyticsPanel: true,
        isShowConceputallySimilartabAnalyticsPanel: true,
        isShowRelatedDocstab: true,
        isShowFoldersTab: true,
        shouldCompleteOnApplyCodingStamp: false,
        isAutoSaveCodingForm: false,
        isShowAiPredictionHints: true,
      },
      docPresentationSorting: {
        isCategory: true,
        isMetadata: false,
        selectedMetaDataFieldId: 0,
        metaDataSeq: 0,
        metaDataDirection: true,
        isImportList: false,
        isAIScore: false,
        selectedModelAiScoreId: 0,
        aiScoreModelDirection: false,
        shouldDisplayEmailTogether: true,
        shouldDisplayFamilyTogether: true,
        aiChkForFamilyTogether: true,
        aiChkForEmailsTogether: true,
        metadatChkForFamilyTogether: true,
        metadataChkForEmailsTogether: true,
      },
      selectCodingFormLists: '',
      pageSize: 0,
      pageNumber: 0,
      isAscending: '',
      sortingColumn: '',
      totalDocuments: 0,
      unAssignedDocuments: 0,
      noOfDocToDistribute: 0,
      assignmentKeywordIds: [],
      assignmentMetaDataIds: [],
      isTemporary: true,
      isLockNeeded: true,
      isAIEnabled: true,
      distributeFamilyDocuments: true,
      distributeEmailThreadDocuments: true,
    },
  },
  assignmentList: {
    tableData: [],
    totalRecords: 0,
  },
  selectedData: {
    type: 'assignment',
    mode: 'create',
    assignmentId: 0,
    assignmentGroupId: -1,
  },
  bulkAssignFlowData: {
    isBulkAssignFlow: false,
    parentGroupId: null,
    masterDocListId: null,
    assignmentId: null,
    bulkActionId: null,
  },
  backSourceTabIndex: null,
  assignmentTree: [],
};

const assignmentSlice = createSlice({
  name: 'assignment',
  initialState,
  reducers: {
    setSelectedData(state, action: PayloadAction<ISelectedData>) {
      state.selectedData = action.payload;
    },
    setListData(state, action: PayloadAction<any>) {
      state.listData = action.payload;
    },
    setFormData(state, action: PayloadAction<any>) {
      state.formData = action.payload;
    },
    setAssignedMetadata(state, action: PayloadAction<IMetadataItem[]>) {
      state.listData.assignedMetadata = action.payload;
    },
    setUnassignedMetadata(state, action: PayloadAction<IMetadataItem[]>) {
      state.listData.unAssignedMetadata = action.payload;
    },
    setAdditionalPrefs(state, action: PayloadAction<any>) {
      state.formData.assignmentModel.additionalPreferences = action.payload;
    },
    setAssignmentKeywordIds(state, action: PayloadAction<any>) {
      state.formData.assignmentModel.assignmentKeywordIds = action.payload;
    },
    setSelectedCodingFormLists(state, action: PayloadAction<string>) {
      state.formData.assignmentModel.selectCodingFormLists = action.payload;
    },
    setAssignmentInstructions(state, action: PayloadAction<string>) {
      state.formData.assignmentModel.assignmentInstructions = action.payload;
    },
    setAssignmentList(state, action: PayloadAction<any>) {
      state.assignmentList = action.payload;
    },
    setSelectedMetaDataFieldId(state, action: PayloadAction<number>) {
      state.formData.assignmentModel.docPresentationSorting.selectedMetaDataFieldId =
        action.payload;
    },
    setSelectedMetaDataDirection(state, action: PayloadAction<boolean>) {
      state.formData.assignmentModel.docPresentationSorting.metaDataDirection =
        action.payload;
    },
    setMetaDataChkForEmailsTogether(state, action: PayloadAction<boolean>) {
      state.formData.assignmentModel.docPresentationSorting.metadataChkForEmailsTogether =
        action.payload;
    },
    setMetaDatChkForFamilyTogether(state, action: PayloadAction<boolean>) {
      state.formData.assignmentModel.docPresentationSorting.metadatChkForFamilyTogether =
        action.payload;
    },
    setLstCategorySeq(state, action: PayloadAction<liveCategorySequence[]>) {
      state.listData.docPresentationSorting.lstCategorySeq = action.payload;
    },
    setClassification(state, action: PayloadAction<number>) {
      state.formData.assignmentModel.classificationLevelID = action.payload;
    },
    setPriority(state, action: PayloadAction<number>) {
      state.formData.assignmentModel.priority = action.payload;
    },
    setIsDrawFromPool(state, action: PayloadAction<boolean>) {
      state.formData.assignmentModel.isDrawFromPool = action.payload;
    },
    setDrawFromPoolCount(state, action: PayloadAction<number>) {
      state.formData.assignmentModel.drawFromPoolCount = action.payload;
    },
    setKeepFamiliesTogether(state, action: PayloadAction<boolean>) {
      state.formData.assignmentModel.isKeepFamiliesTogether = action.payload;
    },
    setEmailThreadsTogether(state, action: PayloadAction<boolean>) {
      state.formData.assignmentModel.isKeepEmailThreadsTogether =
        action.payload;
    },
    setBulkAssignFlowData: (
      state,
      action: PayloadAction<{
        parentGroupId: number;
        masterDocListId: number;
        assignmentId: number;
        bulkActionId: number;
      }>
    ) => {
      state.bulkAssignFlowData = {
        isBulkAssignFlow: true,
        ...action.payload,
      };
    },
    setBackSourceTabIndex(state, action: PayloadAction<number>) {
      state.backSourceTabIndex = action.payload;
    },
    clearBackSourceTabIndex(state) {
      state.backSourceTabIndex = null;
    },
    clearBulkAssignFlowData: (state) => {
      state.bulkAssignFlowData = {
        isBulkAssignFlow: false,
        parentGroupId: null,
        masterDocListId: null,
        assignmentId: null,
        bulkActionId: null,
      };
    },
    resetAssignmentState: () => initialState,
    setAssignmentTree(state, action: PayloadAction<IAssignmentGroupNode[]>) {
      state.assignmentTree = action.payload ?? [];
    },
  },
});

export const {
  setSelectedData,
  setListData,
  setFormData,
  setAssignedMetadata,
  setUnassignedMetadata,
  setAdditionalPrefs,
  setAssignmentKeywordIds,
  setSelectedCodingFormLists,
  setAssignmentInstructions,
  setAssignmentList,
  setSelectedMetaDataDirection,
  setSelectedMetaDataFieldId,
  setMetaDataChkForEmailsTogether,
  setMetaDatChkForFamilyTogether,
  setLstCategorySeq,
  setClassification,
  setPriority,
  setIsDrawFromPool,
  setDrawFromPoolCount,
  setKeepFamiliesTogether,
  setEmailThreadsTogether,
  resetAssignmentState,
  setBulkAssignFlowData,
  setBackSourceTabIndex,
  clearBackSourceTabIndex,
  clearBulkAssignFlowData,
  setAssignmentTree
} = assignmentSlice.actions;
export default assignmentSlice.reducer;
